import { render, staticRenderFns } from "./Position.vue?vue&type=template&id=0574ced5"
import script from "./Position.vue?vue&type=script&lang=js"
export * from "./Position.vue?vue&type=script&lang=js"
import style0 from "./Position.vue?vue&type=style&index=0&id=0574ced5&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0574ced5')) {
      api.createRecord('0574ced5', component.options)
    } else {
      api.reload('0574ced5', component.options)
    }
    module.hot.accept("./Position.vue?vue&type=template&id=0574ced5", function () {
      api.rerender('0574ced5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/clinic/Position.vue"
export default component.exports